export const GET_CATEGORYDATA = 'GET_CATEGORYDATA';
export const SET_CATEGORYDATA = 'SET_CATEGORYDATA';
export const GET_CATEGORYBYID = 'GET_CATEGORYBYID';
export const SET_CATEGORY = 'SET_CATEGORY';
export const GET_CREATEUPDATECATEGORY = 'GET_CREATEUPDATECATEGORY';
export const GET_SAVEDCATEGORYFLAG = 'GET_SAVEDCATEGORYFLAG';
export const SET_SAVEDCATEGORYFLAG = 'SET_SAVEDCATEGORYFLAG';
export const SET_ERRORCATEGORYFLAG = 'SET_ERRORCATEGORYFLAG';
export const SET_CATEGORYNAME = 'SET_CATEGORYNAME';